// Dizayn tokenlari — YAGONA manba (07-FRONTEND.md §3, §4).
//
// Tailwind olib tashlangani uchun ranglar endi CSS o'zgaruvchilarida emas,
// antd `theme.token` ida turadi. antd v5 CSS-in-JS ishlatadi va butun
// komponentlar palitrasini shu tokenlardan HOSIL QILADI — ya'ni bu yerda
// bitta qiymat o'zgarsa, jadval, forma va modal birgalikda o'zgaradi.
// Ikkinchi manba yaratmang: komponent ichida qattiq rang yozilsa, tema
// almashganda o'sha joy qorayib qoladi.
//
// Qorong'i palitra MVP'dan olingan (to'q navy), o'zi o'ylab topilgan emas.

import { theme, type ThemeConfig } from 'antd'
import type { ThemeMode } from './ThemeContext'

const FONT_FAMILY =
  "'Inter Variable', Inter, ui-sans-serif, system-ui, 'Segoe UI', Roboto, sans-serif"

// Brend rangi #ED4325 oq matn bilan 3,87 beradi — tugma uchun bir pog'ona to'qrog'i olingan (4,63, AA)
const BRAND_PRIMARY = '#D9381E'
// Xavfli amal to'q sariq asosiy tugmadan ajralib tursin
const DANGER = '#cf1322'
// Matn sifatida ishlatilganda (havola, tanlangan tab) fonga nisbatan 4,5 dan past tushmasin
const PRIMARY_TEXT = { light: '#C4311A', dark: '#F26A4F' } as const
const SIDER_BG = '#0b1220'

export const HEADER_BG: Record<ThemeMode, string> = {
  light: '#ffffff',
  dark: SIDER_BG,
}

const sharedToken = {
  borderRadius: 8,
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  wireframe: false,
  colorPrimary: BRAND_PRIMARY,
  colorError: DANGER,
} as const

const siderMenu = {
  darkItemBg: SIDER_BG,
  darkSubMenuItemBg: SIDER_BG,
  darkPopupBg: SIDER_BG,
  darkItemSelectedBg: BRAND_PRIMARY,
  darkItemSelectedColor: '#ffffff',
} as const

export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    ...sharedToken,
    colorLink: PRIMARY_TEXT.light,
    colorPrimaryText: PRIMARY_TEXT.light,
    colorWarningText: '#b45309',
    colorSuccessText: '#15803d',
    colorInfo: '#2563eb',
    colorSuccess: '#16a34a',
    colorWarning: '#d97706',
    colorBgLayout: '#f2f5fa',
  },
  components: {
    Layout: {
      siderBg: SIDER_BG,
      headerBg: HEADER_BG.light,
      bodyBg: '#f2f5fa',
    },
    Menu: siderMenu,
  },
}

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedToken,
    colorLink: '#FF8466',
    colorPrimaryText: PRIMARY_TEXT.dark,
    colorPrimaryTextHover: '#F58A73',
    colorError: '#ff5c5c',
    colorErrorText: '#ff7875',
    colorInfo: '#3b82f6',
    colorSuccess: '#22c55e',
    colorWarning: '#eab308',

    // `colorBgBase` butun neytral shkalani hosil qiladi — shuning uchun
    // faqat shuni navy qilish yetadi, har bir fonni alohida yozish shart emas
    colorBgBase: '#080d18',
    colorBgLayout: '#080d18',
    colorBgContainer: '#101828',
    colorBgElevated: '#161f33',
    colorBorder: '#212f47',
    colorBorderSecondary: '#1b273c',
    colorText: '#e2e8f0',
    colorTextSecondary: '#94a3b8',
    colorTextTertiary: '#64748b',
  },
  components: {
    Layout: {
      siderBg: SIDER_BG,
      headerBg: HEADER_BG.dark,
      bodyBg: '#080d18',
    },
    Menu: siderMenu,
  },
}
